import React from 'react'

import { Flex, SimpleGrid } from '@chakra-ui/react'

import { Input, Select } from '@/components/Form'
import { Currency } from '@/features/offers/constants'
import { CostBudgetType } from '@eapproval/offer-shared'
import { useFormContext, useWatch } from 'react-hook-form'
import CostBudgetTemplateTable from './CostBudgetTemplateTable'

const CostBudgetQuotationTemplateDetailSection = ({
  costBudgetIndex = -1,
  tenderDocumentIndex = -1,
  disabled = false,
}) => {
  const { setValue } = useFormContext()

  const costBudgetType = useWatch({ name: `sourcing.costBudgets.${costBudgetIndex}.detail.type` })

  if (!costBudgetType) {
    return <></>
  }

  return (
    <Flex direction={'column'} gap="3">
      <CostBudgetTemplateTable
        costBudgetIndex={costBudgetIndex}
        tenderDocumentIndex={tenderDocumentIndex}
        disabled={disabled}
      />
      <SimpleGrid columns={3} spacingX="40px" spacingY="15px" mb="5">
        <Select
          name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.currency`}
          label={'Currency'}
          options={Object.values(Currency).map((currency) => ({
            value: currency,
            label: currency,
          }))}
          isRow
          disabled={disabled}
        ></Select>

        {costBudgetType === CostBudgetType.SUPPLY_MATERIAL_ONLY && (
          <>
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.warranty`}
              label="Warranty"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.incoterm`}
              label="Incoterm"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.leadTime`}
              label="Leadtime (weeks)"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
          </>
        )}
        {[CostBudgetType.SUPPLY_SITE_WORK_RFQ, CostBudgetType.SUPPLY_SITE_WORK].includes(costBudgetType) && (
          <>
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.incoterm`}
              label="Incoterm"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.insurance`}
              label="Insurance"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.DLP`}
              label="DLP (Months)"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
            <Input
              name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.leadTime`}
              label="Leadtime (weeks)"
              type="text"
              placeholder=""
              isRow
              isRequired={false}
              isDisabled={disabled}
            />
          </>
        )}

        {(costBudgetType === CostBudgetType.SUPPLY_ENGINEERING_SERVICE ||
          costBudgetType === CostBudgetType.SUPPLY_MAINTENANCE_SERVICE) && (
          <Input
            name={`sourcing.costBudgets.${costBudgetIndex}.detail.tenderDocuments.${tenderDocumentIndex}.quotationTemplate.insurance`}
            label="Insurance"
            type="text"
            placeholder=""
            isRow
            isRequired={false}
            isDisabled={disabled}
          />
        )}
      </SimpleGrid>
    </Flex>
  )
}

export default CostBudgetQuotationTemplateDetailSection
